import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Box } from '@mui/material';

interface PageTransitionProps {
  children: React.ReactNode;
}

/**
 * PageTransition - Attio-style subtle fade transition
 * Very quick (150ms), subtle opacity + slight vertical shift
 */
export const PageTransition: React.FC<PageTransitionProps> = ({ children }) => {
  const location = useLocation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Reset and trigger animation on route change
    setIsVisible(false);
    
    // Small delay to ensure the reset happens before fade in
    const timer = requestAnimationFrame(() => {
      setIsVisible(true);
    });

    return () => cancelAnimationFrame(timer);
  }, [location.pathname]);

  return (
    <Box
      sx={{
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? 'translateY(0)' : 'translateY(4px)',
        transition: 'opacity 150ms ease-out, transform 150ms ease-out',
        minHeight: '100%',
        width: '100%'
      }}
    >
      {children}
    </Box>
  );
};

export default PageTransition;

